import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

function* loadShippingDashboard(action) {
    const {
      data: {
        start_date,
        end_date,
        location_visibility,
        material_visibility,
        exactly_location,
        mill_location_list,
        plant_location_list,
        is_vendor,
        is_admin,
        company_id,
        group_by,
        filter_obj,
        offset,
        limit,
        is_saleorder_page,
        accesstoken,
        check_load,
      },
    } = action.payload
  
    try {
      const res = yield call(
        axios.post,
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/shipping-dashboard`,
        {
          start_date,
          end_date,
          location_visibility,
          material_visibility,
          exactly_location,
          mill_location_list,
          plant_location_list,
          is_vendor,
          is_admin,
          company_id,
          filter_obj,
          group_by,
          offset,
          limit,
          is_saleorder_page,
        },
        { headers: { Authorization: `Bearer ${accesstoken}` } }
      )
  
      yield put(
        actions.loadShippingDashboard.success(
          res.data,
          offset,
          group_by,
          check_load
        )
      )
    } catch (err) {
      console.log(err.message)
      yield put(actions.loadShippingDashboard.failure())
    }
}

function* loadShippingDetail(action) {
  const {
    data: { id, accesstoken },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/shipping-detail`,
      {
        id: id
      },
      { headers: { Authorization: `Bearer ${accesstoken}` } }
    )
    yield put(actions.loadShippingDetail.success(res.data))
  } catch (err) {
    yield put(actions.loadShippingDetail.failure())
  }
}

export default function* watchShippingDashboard() {
    yield all([
        takeEvery(actions.LOAD_SHIPPING_DASHBOARD.REQUEST, loadShippingDashboard),
        takeEvery(actions.LOAD_SHIPPING_DETAIL.REQUEST, loadShippingDetail),
    ])
}
export {
    loadShippingDashboard,
    loadShippingDetail
}